import { Datasource, IDatasource } from 'utility-ts-orm';
import { IStudyGroupTerm } from '../study_group_interfaces';

export interface IStudyGroupTermsDatasource extends IDatasource<IStudyGroupTerm> {}

angular.module('capability-ng-study-groups').factory('ngStudyGroupTermsDatasource', (): IStudyGroupTermsDatasource => {
  return new Datasource<IStudyGroupTerm>({
    updateMode: 'merge'
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/datasources/study_group_terms_datasource.ts